import './index_mWeb.css';
import Card from '../card';
import useTheme from '../../utilities/hooks/theme';
import View from '../view';
import Text from '../text';
import moment from 'moment';
import Constants from '../../constants';
import React from 'react';
import { convertToDollars } from '../../utilities/helper';

interface Props {
  item: any;
  isPoker: boolean;
  newAmount: any;
  isTransfer: any;
  expanded: any;
  setExpanded: any;
}

const TransactionPokerItemMWeb = ({
  item,
  isPoker,
  newAmount,
  isTransfer,
  expanded,
  setExpanded
}: Props) => {
  const { AccountTheme: theme } = useTheme();
  const {
    balance = 0,
    createdOn = '',
    gameId = '',
    game = '',
    _id: id = '',
    entryFee = 0,
    // bonusFee = 0,
    refund = '',
    transactionType = '',
    walletType = 'Game',
    tax = 0,
    matchTitle = null,
    comment = null,
    _id = ''
  } = item;

  const statusColor =
    transactionType === 'debit' ? theme.transactionDebit : theme.transactionCredit;

  const surfaceColor = {
    backgroundColor: '#202a38'
  };

  const simpleTextColor = {
    color: theme.transactionDateTime
  };

  const contentTextColor = {
    color: theme.transactionContentText
  };

  const expandDivider = {
    backgroundColor: theme.transactionExpandIconBorder
  };

  const contentColor = {
    borderTopColor: theme.transactionExpandIconBorder,
    borderLeft: `8px solid ${statusColor}`
  };

  return (
    <Card key={_id} className={'transaction-game-item-container'} style={surfaceColor}>
      <View onPress={() => setExpanded(!expanded)} className={'transaction-game-item-header'}>
        <View
          className={'transaction-game-item-header-wrapper'}
          style={{ borderLeft: `8px solid ${statusColor}` }}>
          <View className={'transaction-game-item-left-part'}>
            {transactionType === 'debit' && (
              <Text
                className={'transaction-game-item-header-text'}
                style={{
                  fontFamily: 'Poppins',
                  color: statusColor
                }}>
                {isPoker ? 'Join Room / Buy In' : 'Joined Contest'}
              </Text>
            )}

            {transactionType === 'credit' && (
              <Text
                className={'transaction-game-item-header-text'}
                style={{
                  fontFamily: 'Poppins',
                  color: statusColor
                }}>
                {refund
                  ? 'Got Refund'
                  : isPoker
                  ? 'Credited Back'
                  : comment
                  ? 'Winning adjustment'
                  : isTransfer
                  ? 'Transfer'
                  : 'Won Contest'}
              </Text>
            )}

            {createdOn ? (
              <Text className={'transaction-game-item-simple-text'} style={simpleTextColor}>
                {moment(new Date(createdOn), 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')}
              </Text>
            ) : null}
            {matchTitle && (
              <Text
                className={'transaction-game-item-content-text'}
                style={simpleTextColor}>{`Match Name : ${matchTitle}`}</Text>
            )}
            {comment && (
              <Text
                className={'transaction-game-item-content-text'}
                style={simpleTextColor}>{`Comment : ${comment}`}</Text>
            )}
            <Text
              className={'transaction-game-item-content-text'}
              style={simpleTextColor}>{`Wallet Type : ${comment ? 'Play' : walletType}`}</Text>
          </View>
          <View className={'transaction-game-item-right-part'}>
            <Text className={'transaction-game-item-amount-text'} style={{ color: statusColor }}>
              {`${transactionType === 'credit' ? '+' : '-'} ${convertToDollars(newAmount)}`}
            </Text>
          </View>
        </View>
        {!isTransfer && (
          <>
            <View className={'transaction-game-item-expand-divider'} style={expandDivider} />
            <View className={'transaction-game-item-expand-wrapper'}>
              {expanded ? (
                <Constants.Svgs.ArrowCollapse fill={theme.transactionExpandIcon} />
              ) : (
                <Constants.Svgs.ArrowExpand fill={theme.transactionExpandIcon} />
              )}
            </View>
          </>
        )}
      </View>
      {expanded && !comment && !isTransfer && (
        <View className={'transaction-game-item-content'} style={contentColor}>
          <div className="transaction__poker__item__content__wrapper__mWeb">
            <Text
              className={'transaction-game-item-content-text'}
              style={contentTextColor}>{`Game Type : `}</Text>
            <Text
              className={'transaction__poker__item__content__value__mWeb'}
              style={contentTextColor}>{`${game}`}</Text>
          </div>

          {tax > 0 && transactionType === 'credit' && (
            <div className="transaction__poker__item__content__wrapper__mWeb">
              <Text
                className={'transaction-game-item-content-text'}
                style={contentTextColor}>{`TDS : `}</Text>
              <Text
                className={'transaction__poker__item__content__value__mWeb'}
                style={contentTextColor}>{`${convertToDollars(tax / 100)} /-`}</Text>
            </div>
          )}

          {!isPoker && (
            <div className="transaction__poker__item__content__wrapper__mWeb">
              <Text
                className={'transaction-game-item-content-text'}
                style={contentTextColor}>{`Entry Fee : `}</Text>
              <Text
                className={'transaction__poker__item__content__value__mWeb'}
                style={contentTextColor}>{`${convertToDollars(entryFee / 100)}/-`}</Text>
            </div>
          )}
          <div className="transaction__poker__item__content__wrapper__mWeb">
            <Text
              className={'transaction-game-item-content-text'}
              style={contentTextColor}>{`Game Id : `}</Text>
            <Text
              className={'transaction__poker__item__content__value__mWeb'}
              style={contentTextColor}>{`${gameId}`}</Text>
          </div>
          <div className="transaction__poker__item__content__wrapper__mWeb">
            <Text
              className={'transaction-game-item-content-text'}
              style={contentTextColor}>{`Transaction Id : `}</Text>
            <Text
              className={'transaction__poker__item__content__value__mWeb'}
              style={contentTextColor}>{`${id}`}</Text>
          </div>
          <div className="transaction__poker__item__content__wrapper__mWeb">
            <Text
              className={'transaction-game-item-content-text'}
              style={contentTextColor}>{`Balance : `}</Text>
            <Text
              className={'transaction__poker__item__content__value__mWeb'}
              style={contentTextColor}>{`${convertToDollars(balance / 100)}/-`}</Text>
          </div>
        </View>
      )}
    </Card>
  );
};
export default React.memo(TransactionPokerItemMWeb);
